import { Component, Prop, Vue } from 'vue-property-decorator';
import InputBase from '@/components/inputs/base/InputBase';
import moment from 'moment';
import { McsisConstants } from '@/models/constants/McsisConstants';
// tslint:disable-next-line: no-var-requires
const Datepicker = require('@hokify/vuejs-datepicker').default;

@Component({
  components: {
    Datepicker,
  },
})
export default class InputTime extends InputBase<Date> {
  // @Prop({ default: '' }) public min?: string;
  @Prop({ default: '' }) public max?: string;
  @Prop({ default: true }) public typeable?: boolean;
  @Prop({ default: false }) public clearButton?: boolean;
  @Prop({ default: false }) public calendarButton?: boolean;
  public formatter = McsisConstants.SwissDateFormat;

  /**
   * Gets the language to use for the component
   */
  public get lang() {
    return this.$i18n.locale;
  }

  /**
   * Gets the list of disabled
   */
  public get disabledDates() {
    return {
      to: this.min ? moment(this.min).toDate() : McsisConstants.EmptyString,
      from: this.max ? moment(this.max).toDate() : McsisConstants.EmptyString,
    };
  }

  /**
   * Emit the date value as a JSON string in order to reset the timezone
   * @param date The input date given by the Datepicker component
   */
  public updateValue(date: string) {
    if (date) {
      this.$emit('input', moment(date).format(McsisConstants.EmptyString));
    } else {
      this.$emit('input', date);
    }
  }

  /**
   * Format the date to display to the end-user
   * @param date The date value to format
   */
  public customFormatter(date: string) {
    return moment(date).format(McsisConstants.SlotTimeFormat);
  }

  /**
   * Initializes the component
   */
  protected mounted() {
    this.setInputMode();
  }

  /**
   * Sets inputmode="numeric" on the datepicker input for mobile keyboard
   */
  private setInputMode() {
    this.$nextTick(() => {
      const input = this.$el.querySelector('input');
      if (input) {
        input.setAttribute('inputmode', 'numeric');
      }
    });
  }
}
